const fr = {
  common: {
    languages: { en: "English", de: "Deutsch", nl: "Nederlands", fr: "Français" },
  },

  maintenance: {
    title: "Maintenance en cours",
    body: "Sibolab est actuellement en maintenance. Nous serons de retour en ligne sous peu. Merci de votre patience.",
  },

  updateBanner: {
    message: "Une nouvelle version du portail est disponible.",
    refresh: "Actualiser",
    close: "Fermer",
  },

  session: {
    accessChanged: "Vos droits d'accès ont été modifiés, certaines pages ne vous sont donc plus accessibles. Veuillez contacter Sibolab si vous pensez qu'il s'agit d'une erreur.",
  },

  sidebar: {
    portalLabels: {
      admin: "Ouvrir le portail administrateur",
      therapist: "Ouvrir le portail thérapeute",
      patient: "Ouvrir le portail client",
    },
    roleLabels: {
      admin: "Administrateur",
      operator: "Opérateur",
      therapist: "Thérapeute",
      patient: "Client",
    },
    nav: {
      dashboard: "Tableau de bord",
      myOrders: "Mes commandes",
      myReports: "Mes rapports",
      myPatients: "Mes patients",
      reports: "Rapports",
    },
    account: {
      signedIn: "Connecté",
      settings: "Paramètres",
      logout: "Se déconnecter",
    },
  },

  languageSwitcher: {
    promptTitle: "Changer la langue du portail ?",
    promptBody: "Cette langue doit-elle s'appliquer à chaque connexion, ou seulement pour cette session ?",
    justForNow: "Juste pour l'instant",
    saveForNextTime: "Enregistrer pour la prochaine fois",
  },

  twoFactorPrompt: {
    title: "Comment souhaitez-vous vous connecter ?",
    body: "Pour plus de sécurité, nous pouvons vous envoyer un code à usage unique par e-mail à chaque connexion. Si vous désactivez cette option, vous vous connecterez uniquement avec votre adresse e-mail et votre mot de passe.",
    enable: "Garder le code par e-mail (recommandé)",
    disable: "Se connecter sans code",
    changeLater: "Vous pouvez modifier ce choix à tout moment dans Paramètres → Compte.",
    error: "Impossible d'enregistrer votre choix. Veuillez réessayer.",
  },
  settings: {
    dialog: {
      groupLabel: "Paramètres",
      general: "Général",
      account: "Compte",
    },
    unsaved: {
      title: "Modifications non enregistrées",
      body: "Certaines modifications n'ont pas encore été enregistrées. Voulez-vous les enregistrer avant de quitter ?",
      save: "Enregistrer",
      discard: "Abandonner",
      keepEditing: "Continuer la modification",
      saveError: "Certaines modifications n'ont pas pu être enregistrées. Veuillez vérifier les messages sur la page.",
    },
    general: {
      title: "Profil",
      fullName: "Nom complet",
      country: "Pays",
      countryPlaceholder: "Sélectionner un pays",
      language: "Langue",
      languagePlaceholder: "Sélectionner une langue",
      lastLogin: "Dernière connexion : {{date}}",
      memberSince: "Membre depuis : {{date}}",
      saveChanges: "Enregistrer les modifications",
      profileUpdated: "Profil mis à jour",
      loadError: "Impossible de charger le profil",
      saveError: "Impossible de mettre à jour le profil",
    },
    account: {
      title: "Compte",
      changePassword: "Changer le mot de passe",
      previousPasswordPlaceholder: "Mot de passe actuel",
      newPasswordPlaceholder: "Nouveau mot de passe",
      confirmNewPasswordPlaceholder: "Confirmer le nouveau mot de passe",
      cancel: "Annuler",
      updatePassword: "Mettre à jour le mot de passe",
      passwordUpdated: "Mot de passe mis à jour avec succès.",
      errors: {
        fillAllFields: "Veuillez remplir tous les champs du mot de passe.",
        mismatch: "Le nouveau mot de passe et la confirmation ne correspondent pas.",
        requirements: "Le nouveau mot de passe ne respecte pas les exigences ci-dessus.",
        generic: "Échec de la modification du mot de passe",
      },
      twoFactor: {
        title: "Connexion en deux étapes (code par e-mail)",
        label: "Demander un code par e-mail lors de la connexion",
        noteOn: "Nous vous envoyons un code à usage unique par e-mail à chaque connexion.",
        noteOff: "Vous vous connectez uniquement avec votre e-mail et votre mot de passe (moins sûr).",
        save: "Enregistrer",
        saved: "Paramètre de connexion en deux étapes enregistré.",
        saveError: "Impossible d'enregistrer le paramètre de connexion en deux étapes.",
        loadError: "Impossible de charger votre paramètre de connexion en deux étapes.",
        confirmTitleOn: "Activer la connexion en deux étapes ?",
        confirmBodyOn: "À partir de votre prochaine connexion, nous vous enverrons un code à usage unique par e-mail à chaque connexion.",
        confirmTitleOff: "Désactiver la connexion en deux étapes ?",
        confirmBodyOff: "À partir de votre prochaine connexion, vous vous connecterez uniquement avec votre adresse e-mail et votre mot de passe, sans code par e-mail. C'est moins sûr.",
        confirm: "Confirmer",
        cancel: "Annuler",
      },
      communicationPreferences: {
        title: "Préférences de communication",
        loadError: "Impossible de charger vos préférences de communication.",
        savePreferences: "Enregistrer les préférences",
        saved: "Préférences enregistrées.",
        saveError: "Impossible d'enregistrer les préférences.",
      },
      therapistApplication: {
        title: "Candidature de thérapeute",
        pending: "Votre candidature est en cours d'examen.",
        revoked: "Votre accès thérapeute a été révoqué. Contactez le support si vous avez des questions.",
        rejected: "Votre candidature n'a pas été approuvée. Contactez le support si vous avez des questions.",
        reapply: "Postuler à nouveau",
        interested: "Intéressé(e) à proposer vos services via Sibolab ? Postulez pour devenir thérapeute.",
        apply: "Postuler pour devenir thérapeute",
        cancel: "Annuler",
        submit: "Envoyer la candidature",
        errors: {
          fieldsRequired: "Renseignez le nom, la ville et l'e-mail de votre cabinet.",
          docsRequired: "Ajoutez au moins un document de licence ou de certificat.",
          generic: "Une erreur s'est produite lors de l'envoi de votre candidature.",
        },
      },
    },
  },

  auth: {
    emailHint: "L'e-mail peut mettre une minute à arriver. Pensez aussi à vérifier vos courriers indésirables (spam).",
    layout: {
      title: "Portail Sibolab",
      subtitleDesktop:
        "Gérez vos tests de laboratoire, suivez vos commandes, analysez les résultats et optimisez votre flux de travail — le tout au même endroit.",
      subtitleMobile: "Gérez vos tests de laboratoire, suivez vos commandes et consultez les résultats au même endroit.",
      copyright: "© {{year}} Sibolab. Tous droits réservés.",
    },

    login: {
      title: "Connexion",
      subtitle: "Saisissez vos identifiants pour accéder au portail",
      emailPlaceholder: "votre@email.com",
      passwordPlaceholder: "Mot de passe",
      emailRequired: "L'e-mail est requis",
      invalidEmail: "E-mail invalide",
      passwordRequired: "Le mot de passe est requis",
      forgotPassword: "Mot de passe oublié ?",
      submit: "Se connecter",
      submitting: "Connexion en cours...",
      newToSibolab: "Nouveau sur Sibolab ?",
      createAccount: "Créer un compte",
      errors: {
        shadowAccount: "Vous n'avez pas encore de compte sur le portail. Veuillez en créer un avec cette adresse e-mail.",
        badRequest: "L'e-mail et le mot de passe sont requis.",
        invalidCredentials: "E-mail ou mot de passe incorrect.",
        inactive: "Ce compte est inactif. Contactez un administrateur.",
        tooMany: "Trop de tentatives de connexion. Veuillez patienter quelques minutes puis réessayer.",
        generic: "Connexion impossible pour le moment. Vérifiez votre connexion et réessayez.",
      },
      otp: {
        title: "Saisir le code de vérification",
        subtitle: "Nous avons envoyé un code à 6 chiffres à {{email}}. Saisissez-le ci-dessous.",
        incorrectCode: "Code incorrect ou expiré. Veuillez vérifier le code reçu par e-mail et réessayer, ou en demander un nouveau.",
        verify: "Vérifier le code",
        verifying: "Vérification…",
        notSeeing: "Vous ne voyez pas l'e-mail ?",
        sendNewCode: "Envoyer un nouveau code",
        sending: "Envoi…",
        wrongEmail: "Mauvais e-mail ?",
        changeEmail: "Changer d'adresse e-mail",
        resendNotice: "Un nouveau code a été envoyé - consultez votre e-mail et saisissez-le ci-dessous.",
        resendError: "Impossible de renvoyer. Veuillez réessayer.",
      },
    },

    register: {
      emailStep: {
        title: "Créer votre compte",
        subtitle: "Saisissez votre e-mail pour commencer.",
        submit: "Continuer",
      },
      alreadyHaveAccount: "Vous avez déjà un compte ?",
      signIn: "Se connecter",
      errors: {
        tooMany: "Trop de tentatives - veuillez patienter quelques minutes puis réessayer.",
        generic: "Une erreur s'est produite. Veuillez réessayer.",
      },
      accountExists: {
        title: "Ce compte existe déjà",
        withTherapist:
          "Ce compte existe déjà. Connectez-vous - vous pourrez ensuite demander à devenir thérapeute depuis votre compte si vous le souhaitez.",
        withoutTherapist: "Ce compte existe déjà, veuillez vous connecter.",
        goToLogin: "Aller à la connexion",
        wrongEmail: "Mauvais e-mail ?",
        tryDifferent: "Essayer un autre e-mail",
      },
      otp: {
        title: "Consultez votre e-mail",
        subtitle: "Nous avons envoyé un code à 6 chiffres à {{email}}. Saisissez-le ci-dessous.",
        tooMany: "Trop de tentatives, veuillez réessayer plus tard.",
        incorrectCode: "Code incorrect ou expiré. Veuillez vérifier le code reçu par e-mail et réessayer, ou en demander un nouveau.",
        verify: "Vérifier le code",
        checking: "Vérification…",
        resent: "Code renvoyé - vérifiez votre e-mail.",
        notSeeing: "Vous ne voyez pas l'e-mail ?",
        sendNewCode: "Envoyer un nouveau code",
        wrongEmail: "Mauvais e-mail ?",
        changeEmail: "Changer d'adresse e-mail",
        resendError: "Impossible de renvoyer le code. Veuillez réessayer.",
      },
      completeErrors: {
        expiredCode: "Votre code a expiré. Veuillez vérifier à nouveau.",
        accountExists: "Un compte existe déjà avec cet e-mail.",
        tooMany: "Trop de tentatives, veuillez réessayer plus tard.",
        generic: "Une erreur s'est produite. Veuillez réessayer.",
      },
      therapistApplyFailure:
        "Compte créé - votre candidature de thérapeute n'a pas pu être envoyée : {{reason}}. Vous pouvez réessayer depuis les paramètres du compte.",
    },

    registerDetails: {
      title: "Finaliser la création de votre compte",
      subtitle: "Code vérifié - encore quelques informations et c'est terminé.",
      namePlaceholder: "Nom (facultatif)",
      countryPlaceholder: "Sélectionner un pays",
      languagePlaceholder: "Sélectionner une langue",
      countryRequired: "Veuillez sélectionner votre pays",
      languageRequired: "Veuillez sélectionner votre langue",
      passwordPlaceholder: "Mot de passe",
      confirmPasswordPlaceholder: "Confirmer le mot de passe",
      passwordRequired: "Le mot de passe est requis",
      passwordRequirements: "Le mot de passe ne respecte pas les exigences ci-dessus",
      passwordsMismatch: "Les mots de passe ne correspondent pas",
      therapistFieldsRequired: "Renseignez le nom, la ville et l'e-mail de votre cabinet pour postuler comme thérapeute",
      therapistDocsRequired: "Ajoutez au moins une licence ou un certificat",
      registerAsTherapist: "S'inscrire en tant que thérapeute",
      registerAsTherapistDesc: "Envoyez les informations de votre cabinet et votre licence pour validation par un administrateur.",
      submit: "Créer le compte",
      submitting: "Veuillez patienter…",
    },

    forgotPassword: {
      title: "Réinitialiser votre mot de passe",
      subtitle: "Saisissez l'e-mail de votre compte, nous vous enverrons un code.",
      submit: "Envoyer le code de réinitialisation",
      rememberedIt: "Vous vous en souvenez ?",
      signIn: "Se connecter",
      errors: {
        tooMany: "Trop de tentatives — veuillez patienter quelques minutes puis réessayer.",
        generic: "Une erreur s'est produite. Veuillez réessayer.",
      },
      code: {
        title: "Saisir le code de vérification",
        subtitle: "Si un compte existe pour {{email}}, nous avons envoyé un code à 6 chiffres. Saisissez-le ci-dessous.",
        verify: "Vérifier le code",
        checking: "Vérification…",
        resent: "Code renvoyé — vérifiez votre e-mail.",
        notSeeing: "Vous ne voyez pas l'e-mail ?",
        tryAgain: "Renvoyer",
        wrongEmail: "Mauvais e-mail ?",
        changeEmail: "Changer d'adresse e-mail",
        incorrectCode: "Code incorrect ou expiré. Veuillez vérifier le code reçu par e-mail et réessayer, ou en demander un nouveau.",
        tooMany: "Trop de tentatives, veuillez réessayer plus tard.",
        resendError: "Impossible de renvoyer le code. Veuillez réessayer.",
      },
      done: {
        title: "Mot de passe mis à jour",
        subtitle: "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
        goToSignIn: "Aller à la connexion",
      },
      completeErrors: {
        tooMany: "Trop de tentatives, veuillez réessayer plus tard.",
        generic: "Une erreur s'est produite. Veuillez réessayer.",
      },
      needsRegistration: {
        title: "Aucun mot de passe défini",
        subtitle: "Nous avons trouvé un compte pour cet e-mail, mais aucun mot de passe n'a encore été défini. Créez-en un pour accéder à votre compte.",
        cta: "Créer votre compte",
      },
      notFound: {
        title: "Aucun compte trouvé",
        subtitle: "Nous n'avons trouvé aucun compte pour cette adresse e-mail.",
        cta: "Créer un compte",
        tryDifferentEmail: "Essayer une autre adresse e-mail",
      },
    },

    expiredLink: {
      title: "Ce code a expiré",
      contactPrefix: "Si le problème persiste, veuillez",
      contactLink: "contacter le support",
      tryAgain: "Réessayer",
    },

    setNewPassword: {
      title: "Définir un nouveau mot de passe",
      subtitle: "Code confirmé — choisissez un nouveau mot de passe pour votre compte.",
      newPasswordPlaceholder: "Nouveau mot de passe",
      confirmPasswordPlaceholder: "Confirmer le nouveau mot de passe",
      passwordRequired: "Le mot de passe est requis",
      passwordRequirements: "Le mot de passe ne respecte pas les exigences ci-dessus",
      passwordsMismatch: "Les mots de passe ne correspondent pas",
      submit: "Mettre à jour le mot de passe",
      submitting: "Veuillez patienter…",
    },

    emailStep: {
      emailRequired: "L'e-mail est requis",
      invalidEmail: "E-mail invalide",
    },

    passwordStrength: {
      length: "Au moins 8 caractères",
      lowercase: "Une lettre minuscule",
      uppercase: "Une lettre majuscule",
      number: "Un chiffre",
      special: "Un caractère spécial",
    },

    consent: {
      portalUpdates: "Tenez-moi informé(e) des nouvelles fonctionnalités du portail et des annonces.",
      marketing: "Envoyez-moi la newsletter IBS/SIBO/IMO.",
    },

    therapistApply: {
      practiceDetails: "Détails du cabinet",
      reviewNotice: "Un administrateur examinera ces informations avant l'activation de votre compte thérapeute.",
      practiceName: "Nom du cabinet",
      practiceNamePlaceholderPortal: "ex. Kunz Naturheilpraxis",
      practiceCity: "Ville du cabinet",
      practiceCityPlaceholderPortal: "ex. Berlin",
      practiceEmail: "E-mail du cabinet",
      practiceEmailHelp: "Il s'agit de l'e-mail de votre compte, il ne peut pas être modifié ici.",
      licenseCertificates: "Licence / certificats",
    },

    documentUpload: {
      clickOrDrag: "Cliquez pour importer ou glissez-déposez",
      hint: "PDF, PNG ou JPEG, jusqu'à 10 Mo chacun - {{count}}/{{max}} ajoutés.",
      tooMany: "Vous pouvez importer jusqu'à {{max}} documents.",
      invalidType: "{{name}} : seuls les fichiers PDF, PNG et JPEG sont autorisés.",
      tooLarge: "{{name}} : le fichier dépasse la limite de 10 Mo.",
    },

    copyButton: {
      copy: "Copier le code",
      copied: "Copié",
    },
  },

  portal: {
    statusTimeline: {
      steps: {
        unprocessed: {
          label: "Commande reçue",
          bullets: ["Votre commande a été reçue et est en cours de préparation."],
        },
        dispatched: {
          label: "Kit expédié",
          bullets: [
            "Votre kit de test est en route.",
            "Vous recevrez les informations de suivi par e-mail.",
          ],
        },
        received_by_customer: {
          label: "Kit livré",
          bullets: [
            "Votre kit de test a été livré.",
            "Veuillez effectuer le test et retourner votre échantillon avec l'étiquette prépayée.",
          ],
        },
        returned_to_lab: {
          label: "Échantillon reçu par le laboratoire",
          bullets: [
            "Nous avons reçu votre échantillon retourné.",
            "Il est maintenant en file d'attente pour analyse.",
          ],
        },
        processing: {
          label: "Analyse en cours",
          bullets: [
            "Votre échantillon est en cours d'analyse.",
            "Votre rapport sera prêt sous 2 à 3 jours ouvrés.",
          ],
        },
        analysis_completed: {
          label: "Analyse terminée",
          bullets: [
            "Votre analyse est terminée.",
            "Votre rapport sera bientôt disponible.",
          ],
        },
        completed: {
          label: "Rapport prêt",
          bullets: ["Votre rapport est prêt.", "Vous pouvez le consulter ou le télécharger ci-dessous."],
        },
        cancelled: {
          label: "Annulé",
          bullets: ["Ce test a été annulé."],
        },
      },
      cancelledReasons: {
        customer: "Annulé par le client",
      },
      tooltip: {
        completed: "{{label}} — Terminé le {{date}}",
        inProgress: "{{label}} — En cours depuis {{date}}",
      },
    },

    statusFilterChips: {
      all: "Tous",
    },

    orderTestActionChips: {
      copied: "Copié",
      copyFormLink: "Copier le lien du formulaire",
      fillOutForm: "Remplissez votre formulaire",
      reportProcessing: "Rapport en cours de traitement",
    },

    viewDownloadButtons: {
      viewReport: "Voir le rapport",
      download: "Télécharger",
      reportNotFound: "Rapport introuvable.",
      fetchLinkError: "Impossible de récupérer le lien du rapport.",
    },

    roleSwitchIndicator: {
      viewingAs: "Affichage en tant que {{role}}",
    },

    dashboard: {
      recentActivity: {
        title: "Activité récente",
        subtitle: "Vos 5 derniers changements de statut",
        empty: "Aucune activité récente pour le moment.",
      },
      patient: {
        pageTitle: "Tableau de bord",
        pageSubtitle: "Un aperçu de vos commandes et rapports.",
        summary: {
          totalOrders: "Total des commandes",
          inProgress: "En cours",
          completed: "Terminé",
          reportsAvailable: "Rapports disponibles",
        },
        reportsReady: {
          one: "{{count}} rapport prêt à consulter",
          other: "{{count}} rapports prêts à consulter",
        },
        goToReports: "Aller à Mes rapports",
        loadError: "Impossible de charger votre tableau de bord.",
      },
      therapist: {
        pageTitle: "Tableau de bord",
        pageSubtitle: "Un aperçu de vos patients et tests.",
        summary: {
          totalPatients: "Total des patients",
          totalTests: "Total des tests",
          completedThisMonth: "Terminés ce mois-ci",
          inProgress: "En cours",
        },
        loadError: "Impossible de charger votre tableau de bord.",
      },
    },

    orders: {
      patient: {
        title: "Mes commandes",
        subtitle: "Suivez vos kits de test de la commande au rapport.",
        emptyAll: "Vous n'avez pas encore de commande.",
        emptyFiltered: "Aucune commande ne correspond à ce filtre.",
        loadError: "Impossible de charger vos commandes.",
      },
      therapist: {
        title: "Commandes du patient",
        subtitle: "Progression des tests pour ce patient.",
        backLabel: "Retour aux patients",
        emptyAll: "Aucun test pour ce patient pour le moment.",
        emptyFiltered: "Aucun test ne correspond à ce filtre.",
        loadError: "Impossible de charger les commandes.",
        invalidPatient: "Ce lien de patient n'est pas valide.",
      },
    },

    reports: {
      table: {
        order: "Commande",
        test: "Test",
        substrate: "Substrat",
        completed: "Terminé",
        report: "Rapport",
      },
      empty: "Aucun rapport pour le moment.",
      emptyFiltered: "Aucun rapport ne correspond à ces filtres.",
      filters: {
        searchPlaceholder: "Rechercher par commande, ID de test ou substrat",
        dateAny: "Toutes les dates",
        clear: "Effacer",
        done: "Terminé",
      },
      patient: {
        title: "Mes rapports",
        subtitle: "Rapports d'analyses liés à votre compte.",
        loadError: "Impossible de charger vos rapports.",
      },
      therapist: {
        title: "Rapports",
        subtitle: "Rapports de tous les patients qui vous sont liés.",
        loadError: "Impossible de charger les rapports.",
      },
    },

    patients: {
      title: "Mes patients",
      subtitle: "Patients dont les tests vous sont adressés.",
      searchPlaceholder: "Rechercher par nom de patient",
      emptySearch: "Aucun patient ne correspond à votre recherche.",
      emptyAll: "Aucun patient pour le moment.",
      loadError: "Impossible de charger vos patients.",
      table: {
        patient: "Patient",
        dateOfBirth: "Date de naissance",
        tests: "Tests",
        latestTest: "Dernier test",
      },
    },

    noAccess: {
      title: "Aucun accès au portail pour ce compte",
      subtitle:
        "Votre compte n'est actuellement associé à aucun portail. Si vous pensez qu'il s'agit d'une erreur, contactez le support à l'adresse info@sibolab.de.",
    },
  },
};

export default fr;
